type PreferredStoreTypePillProps = {
  label: string;
};

export function PreferredStoreTypePill({ label }: PreferredStoreTypePillProps) {
  return (
    <span className="inline-flex items-center justify-center rounded-full bg-[#f7f7f7] px-4 py-2 text-sm leading-5 tracking-[0.15px] text-[#333]">
      {label}
    </span>
  );
}
